import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Select } from 'antd';
import axios from "axios";
import VehicleTypeCategoryImg from "../routes/vehicleTypes/VehicleTypeCategoryImg";
const VehicleTypeSelect = ({ disabled = false, tenantId, defaultValue, value, performsCustomerDeliveries, marketplaceParticipator, salesOrderApplicableTenantId, mode, allowClear = true, placeholder = "Select a vehicle type", style, onChange, onVehicleTypeChanged }) => {
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [options, setOptions] = useState([]);
    useEffect(() => {
        loadVehicleTypes();
    }, [tenantId]);
    const buildOptions = (vehicleTypes) => {
        const categoryMap = new Map();
        const sortedVehicleTypes = vehicleTypes.sort((vt1, vt2) => {
            if (!categoryMap.has(vt1.category.name)) {
                categoryMap.set(vt1.category.name, vt1.category);
            }
            const catDiff = vt1.category.name.localeCompare(vt2.category.name);
            if (catDiff === 0) {
                return vt1.category.description.localeCompare(vt2.category.description);
            }
            return catDiff;
        });
        const options = [];
        categoryMap.forEach(category => {
            options.push({
                label: _jsxs(_Fragment, { children: [category.description, " ", _jsx(VehicleTypeCategoryImg, { category: category.name, size: 'sm', className: 'pull-right' })] }),
                options: sortedVehicleTypes.filter(vt => vt.category.name === category.name).map(vt => {
                    return {
                        label: vt.description,
                        value: vt.id
                    };
                })
            });
        });
        return options;
    };
    const loadVehicleTypes = () => {
        axios.get('/admin/v1/vehicle-types?limit=999', {
            headers: {
                'FilterTenantId': tenantId
            },
            params: {
                performsCustomerDeliveries,
                marketplaceParticipator,
                salesOrderApplicableTenantId
            }
        }).then(response => {
            const vehicleTypes = response.data.results;
            setOptions(buildOptions(vehicleTypes));
            setVehicleTypes(vehicleTypes);
        });
    };
    const onSelectionChanged = (val) => {
        onChange && onChange(val);
        if (onVehicleTypeChanged) {
            if (typeof val === "number") {
                onVehicleTypeChanged(vehicleTypes.filter(vt => vt.id === val).shift());
            }
            else if (!val) {
                onVehicleTypeChanged(undefined);
            }
        }
    };
    return (_jsx(Select, { mode: mode, disabled: disabled, allowClear: allowClear, placeholder: placeholder, style: style, onChange: onSelectionChanged, value: value, defaultValue: defaultValue, options: options, showSearch: {
            optionFilterProp: ['label']
        } }));
};
export default VehicleTypeSelect;
